"use client";
import React from "react";
import { cloudFrontUrl, cn } from "@/lib/utils";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";

import { Mousewheel, Navigation } from "swiper/modules";
import MaxWidthContainer from "./max-width-container";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { ImageLoader } from "../ui/image-loader";

const ImgGallerySlider = ({ images }: { images: string[] }) => {
  return (
    <MaxWidthContainer className="px-0 pt-12 md:pt-16  ">
      <div className="relative">
        <div className="relative overflow-hidden">
          <div className="absolute -top-32 md:-top-30 lg:-top-28 left-0 z-10 h-36  w-full scale-x-[1.75] rounded-b-[100%] md:scale-x-150 lg:scale-x-125 bg-white" />
          <div className="absolute -bottom-32 md:-bottom-30 lg:-bottom-28 s left-0 z-10 h-36  w-full scale-x-[1.75] rounded-t-[100%] md:scale-x-150 lg:scale-x-125 bg-white" />

          <Swiper
            slidesPerView={1.6}
            loop={true}
            centeredSlides={true}
            mousewheel={{
              forceToAxis: true,
            }}
            breakpoints={{
              0: { spaceBetween: 10 },
              600: { spaceBetween: 16 },
              900: { spaceBetween: 20 },
              1200: { spaceBetween: 24 },
            }}
            spaceBetween={30}
            navigation={{
              nextEl: "#nextimg",
              prevEl: "#previmg",
            }}
            modules={[Mousewheel, Navigation]}
            className="mySwiper"
          >
            {images.map((img, i) => (
              <SwiperSlide key={i}>
                <div className="aspect-[16/11] rounded-xl bg-gray-200">
                  <ImageLoader
                    src={cloudFrontUrl(img)}
                    alt={`Image ${i}`}
                    fill
                    className="rounded-lg object-cover"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <button
          id="previmg"
          className={cn(
            "absolute left-0 top-1/2 z-20 hidden h-6 w-6 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white p-0.5 text-custom-primary shadow-[0px_2px_8px_0px_rgba(0,0,0,0.25)] transition-all duration-300 ease-in-out hover:bg-custom-primary hover:text-white hover:shadow-none disabled:hidden md:block md:h-7 md:w-7 lg:h-8 lg:w-8 lg:p-1",
          )}
        >
          <ChevronLeft className="h-full w-full" />
        </button>
        <button
          id="nextimg"
          className={cn(
            "absolute right-0 top-1/2 z-20 hidden h-6 w-6 -translate-y-1/2 translate-x-1/2 rounded-full bg-white p-0.5 text-custom-primary shadow-[0px_2px_8px_0px_rgba(0,0,0,0.25)] transition-all duration-300 ease-in-out hover:bg-custom-primary hover:text-white hover:shadow-none disabled:hidden md:block md:h-7 md:w-7 lg:h-8 lg:w-8 lg:p-1",
          )}
        >
          <ChevronRight className="h-full w-full" />
        </button>
      </div>
    </MaxWidthContainer>
  );
};

export default ImgGallerySlider;
